import React, { useEffect, useState } from 'react'
import { Button, Form, Input } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import EnglishLanguage from '../../Languages/EnglishLanguage.json'
import { loginUser, removeUser } from '../../Redux/actions/authActions'
import { AUTH } from '../../utils/apis'
import { allPaths } from '../../utils/constants'
import { assignMessage, errorMessage, successMessage, warningMessage } from '../../utils/helpers'
import { Link } from 'react-router-dom'
import axios from 'axios'

const Login = (props) => {
    const { history } = props
    const dispatch = useDispatch()
    const [loading, setLoading] = useState(false)
    const path = history?.location?.pathname
    const language = useSelector(state => state?.languageReducer)
    const selectedLanguage = language?.language === 'english' ? EnglishLanguage : EnglishLanguage
    // const isEnglish = language?.language === 'english'

    const onFinish = (values) => {
        const { history } = props
        values.userType = 'clanic'
        setLoading(true)
        axios.post(AUTH.LOGIN, values)
            .then((res) => {
                const { data } = res
                console.log('=============datajlllllllllllllll', data)
                setLoading(false)
                if (data.success) {
                    dispatch(loginUser(data.user))
                    return history?.replace(allPaths?.HOME)
                }
                errorMessage(data?.message)/* (assignMessage(data.message, language?.language)) */
            })
            .catch((e) => {
                setLoading(false)
                console.log('e', e)
                errorMessage(e?.message)/* (assignMessage(e.message, language?.language)) */
            })
    }

    useEffect(() => {
        dispatch(removeUser())
    }, [])

    return (
        <div className='new-layout-scroll-class'
            style={{
                height: '100vh',
                background: '#A4C8CE',
                overflow: 'auto'
            }}>
            <div style={{ width: '400px', margin: '10px auto' }}>
                <div
                    style={{ display: 'flex', justifyContent: 'center', marginBottom: '10px' }}>
                    <p className="upper-header-txt-logo" style={{ fontSize: 39 }}>
                        {selectedLanguage?.txt_bu_login}
                    </p>
                </div>
                <Form
                    name='form'
                    onFinish={onFinish}
                    layout={'vertical'}
                    requiredMark={false}
                >
                    <div className='form-two-input-flex'>
                        <div className='form-two-input-flex-inner-input'>
                            <Form.Item
                                name='email'
                                label={<p className='new-pp-colr-wht'>{selectedLanguage?.input_email_placeholder}</p>}
                                hasFeedback
                                rules={[
                                    {
                                        required: true,
                                        message: selectedLanguage?.txt_please_input_your_email,
                                    },
                                    {
                                        type: 'email',
                                        message: selectedLanguage?.txt_email_is_not_valid,
                                    },
                                ]}
                            >
                                <Input className='form-input-new-style' placeholder={selectedLanguage?.input_email_placeholder} />
                            </Form.Item>
                        </div>
                        <div className='form-two-input-flex-inner-input'>
                            <Form.Item
                                name='password'
                                label={<p className='new-pp-colr-wht'>{selectedLanguage?.txt_password}</p>}
                                hasFeedback
                                rules={[
                                    {
                                        required: true,
                                        message: selectedLanguage?.txt_please_input_your_password,
                                    },
                                    {
                                        min: 6,
                                        message: selectedLanguage?.txt_password_must_be_atleast_characters,
                                    },
                                ]}
                            >
                                <Input.Password
                                    className='form-input-new-style'
                                    placeholder={selectedLanguage?.txt_password}
                                />
                            </Form.Item>
                        </div>
                    </div>
                    <div className='form-two-input-flex-inner-input' style={{ width: '100%' }}>
                        <Form.Item>
                            <Button
                                type='primary'
                                className='newlogin-btn form-input-new-style'
                                style={{ height: '45px', marginTop: '10px' }}
                                htmlType='submit'
                                block
                                loading={loading}
                            >
                                {selectedLanguage?.txt_login}
                            </Button>
                        </Form.Item>
                    </div>
                </Form>
                <div style={{ textAlign: 'center' }}>
                    <p>
                        {
                            <span>
                                <Link to={allPaths?.DOCTOR_LOGIN}>
                                    {<span className='new-pp-colr-wht'>{selectedLanguage?.txt_doctor_login}
                                    </span>}</Link>
                            </span>
                        }
                    </p>
                </div>
            </div>
        </div>
    )
}

export default Login
